// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

const juniorHealthData = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "What will health insurance cover?",
      answer:
        "The main part of health insurance is the inpatient cover. All medical insurance plans in Kenya must have this option. This covers for all hospital charges when the insured is admitted to a medical facility or hospital. In addition to the inpatient cover, few common options can be added like outpatient, dental, optical and maternity covers.",
    },
    {
      icon: "hdr_weak",
      question: "Who is eligible?",
      answer:
        "All junior resident in Kenya of age 18-65 years may be admitted on cover. Some medical insurance companies may set the oldest joining age at 60 years of age and require a medical test to be taken for members above 55 years of age. Check your medical insurance quote carefully or ask a member of staff.",
    },
    {
      icon: "hdr_strong",
      question: "Can I use my insurance immediately?",
      answer:
        "Yes and No! There is a waiting period of 14 days before the medical insurance can be used for general illnesses. For medical procedures and surgeries, a sixty days waiting period exists. For accidents and emergencies, there is no waiting period. Note : Waiting periods of up to 3 years exist for pre-existing conditions, check your medical insurance quote and policy for details.",
    },
    {
      icon: "hdr_weak",
      question: "How can I save money and get the best medical insurace plan?",
      answer:
        "Compare and Compare! We compare all medical insurance providers in Kenya, products, limits, hospitals and prices. Top tips : Choose an economy health insurance package, these give you exactly the same type of cover as the premium packages but only work on a restricted list of hospitals excluding the leading hospitals in Kenya. Secondly, mix and match the inpatient and outpatient limits, try to keep the inpatient limits no more than KSh 1 million and outpatient limits of KSh 50,000.",
    },
    {
      icon: "hdr_strong",
      question: "How can I make claims on my policy?",
      answer:
        "All medical insurance providers issue a smart card to members. The smart card is to be presented at the medical facility/hospital before seeking treatment. If you seek treatment at a hospital outside of the panel of hospitals on the panel of your insurance company, then you may be forced to pay out of pocket then file for a refund. Note : Each insurer has set limits for refunds for different medical procedures. Confirm with your insurance before seeking treatment outside the prescribed list of medical facilities. For more details on how to raise a medical insurance claim, please check our claims page.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Compare health insurance.",
        description: "Compare health insurance plans from leading providers.",
      },
      {
        icon: "filter_2",
        title: "Choose optional benefits",
        description:
          "Choose optional benefits like outpatient, maternity cover and others.",
      },
      {
        icon: "filter_3",
        title: "Save money",
        description: "Save money on your annual premiums.",
      },
      {
        icon: "filter_4",
        title: "Get expert advice",
        description:
          "Get expert advice from our dedicated health insurance experts.",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "COMPARE & BUY PERSONAL HEALTH INSURANCE ONLINE",
      description:
        "Protect the health of you and your loved ones by getting the best health insurance. Get health insurance to cover all charges for inpatient, outpatient, maternity, dental, optical treatments in wide range of medical providers and hospitals in Kenya and overseas.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Compare Plans",
    },
  },
};

const seniorHealthData = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "What will health insurance cover?",
      answer:
        "The main part of health insurance is the inpatient cover. All medical insurance plans in Kenya must have this option. This covers for all hospital charges when the insured is admitted to a medical facility or hospital. In addition to the inpatient cover, few common options can be added like outpatient, dental, optical and maternity covers.",
    },
    {
      icon: "hdr_weak",
      question: "Who is eligible?",
      answer:
        "All adults resident in Kenya of age 18-65 years may be admitted on cover. Some medical insurance companies may set the oldest joining age at 60 years of age and require a medical test to be taken for members above 55 years of age. Check your medical insurance quote carefully or ask a member of staff.",
    },
    {
      icon: "hdr_strong",
      question: "Can I use my insurance immediately?",
      answer:
        "Yes and No! There is a waiting period of 14 days before the medical insurance can be used for general illnesses. For medical procedures and surgeries, a sixty days waiting period exists. For accidents and emergencies, there is no waiting period. Note : Waiting periods of up to 3 years exist for pre-existing conditions, check your medical insurance quote and policy for details.",
    },
    {
      icon: "hdr_weak",
      question: "How can I save money and get the best medical insurace plan?",
      answer:
        "Compare and Compare! We compare all medical insurance providers in Kenya, products, limits, hospitals and prices. Top tips : Choose an economy health insurance package, these give you exactly the same type of cover as the premium packages but only work on a restricted list of hospitals excluding the leading hospitals in Kenya. Secondly, mix and match the inpatient and outpatient limits, try to keep the inpatient limits no more than KSh 1 million and outpatient limits of KSh 50,000.",
    },
    {
      icon: "hdr_strong",
      question: "How can I make claims on my policy?",
      answer:
        "All medical insurance providers issue a smart card to members. The smart card is to be presented at the medical facility/hospital before seeking treatment. If you seek treatment at a hospital outside of the panel of hospitals on the panel of your insurance company, then you may be forced to pay out of pocket then file for a refund. Note : Each insurer has set limits for refunds for different medical procedures. Confirm with your insurance before seeking treatment outside the prescribed list of medical facilities. For more details on how to raise a medical insurance claim, please check our claims page.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Find health insurance.",
        description: "Find health insurance plans from top providers in Kenya.",
      },
      {
        icon: "filter_2",
        title: "Life cover",
        description: "Members are covered for life once accepted.",
      },
      {
        icon: "filter_3",
        title: "Save money",
        description: "Save money on your annual premiums.",
      },
      {
        icon: "filter_4",
        title: "Pre-existing conditions",
        description: "Pre-existing conditions accepted.",
      },
      {
        icon: "filter_5",
        title: "65-80 year olds",
        description: "65-80 year olds are eligible",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "COMPARE SENIOR HEALTH INSURANCE PLANS ONLINE",
      description:
        "Senior citizens / elderly are the most vulnerable when it comes to illness, pains and related medical conditions and disorders. Most health insurance plans in Kenya don't cover seniors who are the most at risk. Worry no more, we compare the best medical insurance quotes for seniors in Kenya. Compare different inpatient benefits and outpatient benefits with the best network of hospitals in Kenya.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Compare Plans",
    },
  },
};

const individualHealthData = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "What will health insurance cover?",
      answer:
        "The main part of health insurance is the inpatient cover. All medical insurance plans in Kenya must have this option. This covers for all hospital charges when the insured is admitted to a medical facility or hospital. In addition to the inpatient cover, few common options can be added like outpatient, dental, optical and maternity covers.",
    },
    {
      icon: "hdr_weak",
      question: "Who is eligible?",
      answer:
        "All adults resident in Kenya of age 18-65 years may be admitted on cover. Some medical insurance companies may set the oldest joining age at 60 years of age and require a medical test to be taken for members above 55 years of age. Check your medical insurance quote carefully or ask a member of staff.",
    },
    {
      icon: "hdr_strong",
      question: "Can I use my insurance immediately?",
      answer:
        "Yes and No! There is a waiting period of 14 days before the medical insurance can be used for general illnesses. For medical procedures and surgeries, a sixty days waiting period exists. For accidents and emergencies, there is no waiting period. Note : Waiting periods of up to 3 years exist for pre-existing conditions, check your medical insurance quote and policy for details.",
    },
    {
      icon: "hdr_weak",
      question: "How can I save money and get the best medical insurace plan?",
      answer:
        "Compare and Compare! We compare all medical insurance providers in Kenya, products, limits, hospitals and prices. Top tips : Choose an economy health insurance package, these give you exactly the same type of cover as the premium packages but only work on a restricted list of hospitals excluding the leading hospitals in Kenya. Secondly, mix and match the inpatient and outpatient limits, try to keep the inpatient limits no more than KSh 1 million and outpatient limits of KSh 50,000.",
    },
    {
      icon: "hdr_strong",
      question: "How can I make claims on my policy?",
      answer:
        "All medical insurance providers issue a smart card to members. The smart card is to be presented at the medical facility/hospital before seeking treatment. If you seek treatment at a hospital outside of the panel of hospitals on the panel of your insurance company, then you may be forced to pay out of pocket then file for a refund. Note : Each insurer has set limits for refunds for different medical procedures. Confirm with your insurance before seeking treatment outside the prescribed list of medical facilities. For more details on how to raise a medical insurance claim, please check our claims page.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Find health insurance.",
        description: "Find health insurance plans from top providers in Kenya.",
      },
      {
        icon: "filter_2",
        title: "Life cover",
        description: "Members are covered for life once accepted.",
      },
      {
        icon: "filter_3",
        title: "Save money",
        description: "Save money on your annual premiums.",
      },
      {
        icon: "filter_4",
        title: "Pre-existing conditions",
        description: "Pre-existing conditions accepted.",
      },
      {
        icon: "filter_5",
        title: "65-80 year olds",
        description: "65-80 year olds are eligible",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "COMPARE INDIVIDUAL HEALTH INSURANCE PLANS ONLINE",
      description:
        "Individual citizens / elderly are the most vulnerable when it comes to illness, pains and related medical conditions and disorders. Most health insurance plans in Kenya don't cover seniors who are the most at risk. Worry no more, we compare the best medical insurance quotes for seniors in Kenya. Compare different inpatient benefits and outpatient benefits with the best network of hospitals in Kenya.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Compare Plans",
    },
  },
};

const familyHealthData = {
  faqs: [
    {
      icon: "hdr_strong",
      question: "How do I get covered for maternity?",
      answer:
        "All medical insurance companies in Kenya cover maternity subject to a waiting period of 10-12 months. So, it is not possible to get a maternity insurance a pregrancy has started. Some health insurance plans in Kenya cover maternity as part of the InPatient limits while most of the plans offer maternity cover as an optional benefit at an additional cost.",
    },
    {
      icon: "hdr_weak",
      question: "Can I cover my child separately?",
      answer:
        "It is possible to cover juniors less than 18 years old on a medical insurance plan without requiring an adult to be insured on the same plan. However, only plans for inpatient medical insurance are available for juniors.",
    },
    {
      icon: "hdr_strong",
      question: "What about optical and dental covers?",
      answer:
        "Optical and Dental are mainly offered as optional benefits on most of the health insurance options. They offer valuable insurance against common eye and tooth conditions that may cause unplanned physical and financial stress. These two options may only be taken with an inpatient and outpatient plan.",
    },
    {
      icon: "hdr_weak",
      question: "Will this insurance work with my NHIF?",
      answer:
        "Yes, health insurance will work with the NHIF cover. Medical bills incurred in hospital especially for inpatient visits may be paid net of NHIF limits. This means your medical insurance limits will take you further courtesy of the NHIF benefits.",
    },
    {
      icon: "hdr_strong",
      question: "Can I take an outpatient plan only?",
      answer:
        "No, it is not possible to take an outpatient medical insurance plan on its own. All medical insurance plans in Kenya required the insured to take a mandatory in-patient medical option.",
    },
    {
      icon: "hdr_weak",
      question:
        "What happens if I or family member has pre-existing medical conditions?",
      answer:
        "You may still be accepted on cover with the pre-existing conditions. However, pay attention to the waiting periods section of your medical insurance quoation as these will apply. Any and all pre-existing and chronic should be fully disclosed before taking up the health insurance policy, failure to do so may result in cover cancellation.",
    },
  ],
  information: {
    listInformation: [
      {
        icon: "filter_1",
        title: "Compare medical insurance.",
        description:
          "Compare medical insurance quotes from the top insurance companies.",
      },
      {
        icon: "filter_2",
        title: "Choose shared family benefits",
        description:
          "Choose shared family benefits plans or per member benefits.",
      },
      {
        icon: "filter_3",
        title: "Try different optional benefits",
        description:
          "Try different optional benefits like outpatient, maternity cover and others.",
      },
      {
        icon: "filter_4",
        title: "Save money",
        description: "Save money on your annual medical premiums.",
      },
      {
        icon: "filter_5",
        title: "Get family medical plans",
        description:
          "Get family medical plans from as low as KSh 25,000 annual premium.",
      },
    ],
    cardInformation: {
      image:
        "https://images.unsplash.com/photo-1544717302-de2939b7ef71?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=1950&q=80",
      title: "COMPARE FAMILY HEALTH INSURANCE PLANS ONLINE",
      description:
        "Find the best family medical insurance quote for your requirements. Choose shared or per individual medical plans and find flexible limits for the optional benefits like outpatient, maternity dental, optical treatments among others. Compare high end and economy plans that give access to a wide range of medical providers and hospitals in Kenya and overseas.",
      actionRoute: "pages/company/about-us",
      actionLabel: "Compare Plans",
    },
  },
};

// Typechecking props for the seniorHealthData
seniorHealthData.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
seniorHealthData.information.listInformation.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
seniorHealthData.information.cardInformation.propTypes = {
  faqs: PropTypes.object,
};
individualHealthData.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
individualHealthData.information.listInformation.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
individualHealthData.information.cardInformation.propTypes = {
  faqs: PropTypes.object,
};
familyHealthData.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
familyHealthData.information.listInformation.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
familyHealthData.information.cardInformation.propTypes = {
  faqs: PropTypes.object,
};
juniorHealthData.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
juniorHealthData.information.listInformation.propTypes = {
  faqs: PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.object])),
};
juniorHealthData.information.cardInformation.propTypes = {
  faqs: PropTypes.object,
};

export {
  juniorHealthData,
  seniorHealthData,
  familyHealthData,
  individualHealthData,
};
